import SideMenuBar from "./components/SideMenuBar";
import {Menu as MENU, X} from "react-feather";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import API_LINK from "../components/links/Link";
import {ACCESSORIES, INVERTER, PANEL, STORAGE} from "../assets/images/Images";
import {useHistory} from "react-router-dom";

export default function Dashboard() {
    const [walls, setWalls] = useState([])
    const [ceilings, setCeilings] = useState([])
    const history = useHistory();

    const [isMobileShow, setIsMobileShow] = useState(false);

    document.title = "eSelector Tools || Dashboard";

    // const LoadEnergyStorage = async () => {
    //     try {
    //         setIsLoading(true);
    //         let formdata = new FormData();
    //         formdata.append("page", "LoadEnergyStorage");
    //         var requestOptions = {
    //             method: 'POST', body: formdata, redirect: 'follow'
    //         };
    //
    //         await fetch(`${API_LINK}Solar.php`, requestOptions)
    //             .then(response => response.json())
    //             .then(result => {
    //                 console.log(result)
    //                 if (result.status === 1) {
    //                     if (result.data.length > 0) {
    //                         setEnergyStorageData(result.data);
    //                         setEnergyStorageFilter(result.data);
    //                     }
    //                 } else {
    //                     toast.error("Server Error! Please try again later.")
    //                 }
    //                 setIsLoading(false);
    //             }).catch(error => console.log('error', error));
    //     } catch (e) {
    //         console.log(e)
    //     }
    // }

    return (<>
        {/*<MenuHeader page={'dashboard'}/>*/}

        <div className='dashboard-container'>
            <SideMenuBar mobileShow={isMobileShow}/>
            <div className="dashboard-content" data-aos={'fade-left'}>
                <div className="content">
                    <button className='btn_dashboard_menu' onClick={() => setIsMobileShow(true)}>
                        <MENU size={16}/>
                        <span>Show Menu</span>
                    </button>
                    <button className={`btn_dashboard_close_menu ${isMobileShow ? "show" : "hide"}`}
                            onClick={() => setIsMobileShow(false)}>
                        <X size={16}/>
                    </button>
                    <h2>Welcome Back! {localStorage.getItem("UserName")}</h2>
                    <div className="dashboard-cards-container">
                        <div className="dashboard-card">
                            <div className="icon">
                                <img src={PANEL} alt="Solar Panel"/>
                                {/*<VscCompassActive/>*/}
                            </div>
                            <div className="detail">
                                <h2 className="heading">{walls.length}</h2>
                                <p>Walls</p>
                            </div>
                        </div>
                        <div className="dashboard-card">
                            <div className="icon">
                                <img src={INVERTER} alt="Solar Inverter"/>
                            </div>
                            <div className="detail">
                                <h2 className="heading">{ceilings.length}</h2>
                                <p>Ceilings</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
